<mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header class="section-panel-header">
        <mat-panel-title>
            <app-section-header
                [title]="sectionDescription.title"
                [description]="sectionDescription.description"
            ></app-section-header>
        </mat-panel-title>
    </mat-expansion-panel-header>

    <div formGroupName="domainHosting">
        <mat-radio-group
            formControlName="domainType"
            id="domain-type"
            class="domain-type-group"
            aria-label="Domain type"
        >
            <mat-radio-button value="subdomain" id="domain-type-subdomain">
                Use a CargoSprint subdomain
            </mat-radio-button>
            <mat-radio-button value="custom" id="domain-type-custom">
                Use a custom domain (customer-owned)
            </mat-radio-button>
        </mat-radio-group>

        @if (isSubdomain) {
            <div class="row domain-input-wrapper mt-3">
                <div class="col-9">
                    <mat-form-field appearance="outline" class="domain-input-field">
                        <mat-label>Subdomain name</mat-label>
                        <input
                            matInput
                            formControlName="domainValue"
                            id="subdomain-value"
                            placeholder="subdomain"
                            autocomplete="off"
                        />

                        @if (isRequiredError) {
                            <mat-error>Subdomain is required.</mat-error>
                        }
                        @if (subdomainFormatError) {
                            <mat-error>{{ subdomainFormatError }}</mat-error>
                        }
                        @if (subdomainReservedError) {
                            <mat-error>{{ subdomainReservedError }}</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="col-3 domain-suffix">
                    <span aria-label="Domain suffix">.cargosprint.com</span>
                </div>
            </div>

            @if (domainValueControl.valid && domainValueControl.value) {
                <p class="domain-preview mt-1 d-flex">
                    <mat-icon inline class="domain-preview-icon">language</mat-icon>
                    Your portal will be available at:&nbsp;
                    <strong id="resolved-domain-preview">{{ resolvedDomain }}</strong>
                </p>
            }
        }

        @if (isCustom) {
            <mat-form-field appearance="outline" class="full-width mt-3">
                <mat-label>Full domain</mat-label>
                <input
                    matInput
                    formControlName="domainValue"
                    id="custom-domain-value"
                    placeholder="pay.customer.com"
                    autocomplete="off"
                />

                @if (isRequiredError) {
                    <mat-error>Domain is required.</mat-error>
                }
                @if (customDomainProtocolError) {
                    <mat-error>{{ customDomainProtocolError }}</mat-error>
                }
                @if (customDomainPathError) {
                    <mat-error>{{ customDomainPathError }}</mat-error>
                }
                @if (customDomainNoDotError) {
                    <mat-error>{{ customDomainNoDotError }}</mat-error>
                }
                @if (customDomainLengthError) {
                    <mat-error>{{ customDomainLengthError }}</mat-error>
                }
                @if (customDomainLabelError) {
                    <mat-error>{{ customDomainLabelError }}</mat-error>
                }
            </mat-form-field>

            <div>
                <p class="domain-hint mt-1">
                    <mat-icon inline class="domain-hint-icon lh-1">info_outline</mat-icon>
                    Enter your full domain without the protocol (e.g.&nbsp;<code>pay.customer.com</code>). DNS
                    configuration will be required after creation.
                </p>
            </div>
        }
    </div>
</mat-expansion-panel>
